import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "../../api/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VerificationService {
  constructor(private apiService: ApiService) { }

  getRequests(req: {
    status?: string;
    type?: string;
    search?: string;
    page: number;
    limit: number;
  }): Observable<any> {
    let params = new HttpParams()
      .set("page", String(req.page))
      .set("limit", String(req.limit));

    if (req.status) {
      params = params.set("status", req.status);
    }
    if (req.type) {
      params = params.set("type", req.type);
    }
    if (req.search) {
      params = params.set("search", req.search);
    }

    return this.apiService.get<any>({
      Url: "dating/admin/verification",
      Params: params,
    });
  }

  approveRequest(id: string, type: 'Didit Kyc' | 'Manual', reason?: string): Observable<any> {
    return this.apiService.post<any, any>({
      Url: `dating/admin/verification/${id}/approve`,
      Body: { type, reason },
    });
  }

  rejectRequest(id: string, type: 'Didit Kyc' | 'Manual', reason?: string): Observable<any> {
    return this.apiService.post<any, any>({
      Url: `dating/admin/verification/${id}/reject`,
      Body: { type, reason },
    });
  }

  deleteRequest(id: string): Observable<any> {
    return this.apiService.delete<any, any>({
      Url: `dating/admin/verification/${id}`,
      Body: {},
    });
  }
}
